import React from 'react';

import CreditCardInput from 'react-credit-card-input';
import { connect } from "react-redux";
import {addPaymentMethod} from '../../../services/patient/action'
import $ from 'jquery';
import {footer} from "../../../components/footerSize";

class PatientPayment extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            person_name: "",
            card_number: "",
            card_exp: "",
            card_cvv: ""
        }
    }

    changeName = (e) => {
        this.setState({
            person_name: e.target.value
        })
    }

    handleCardNumberChange = (e) => {
        this.setState({
            card_number: e.target.value
        })
 
    }

    handleCardExpiryChange = (e) => {
        this.setState({
            card_exp: e.target.value
        })
    }

    handleCardCVCChange = (e) => {
        this.setState({
            card_cvv: e.target.value
        })
    }

    addCard = () => {
        let { card_number, card_cvv, card_exp, person_name } = this.state;

        let expOne = card_exp.slice(0,2)
        let expTwo = card_exp.slice(5,7)
         card_exp = expOne+expTwo
        let data = this.props.profileDetails.commonUser;

        let Type = card_number.charAt(0);
        let card_type ;

            // switch(Type){
            //     case "4":
            //     card_type = "Visa",
            //     break;
            // }


            switch(Type){
                case "4":
                card_type ="Visa"
                break;
                case "5":
                card_type ="MasterCard"
                break;
                case "3":
                card_type ="Amex"
                break;   
                case "6":
                card_type ="Discover"
                break;
                default:
                break;
            } 
 
            let token = this.props.loginDetails;

        let userId = data.userId;
        let address_zip = (data.zip).toString()
      
          
    //    let cardOne = card_number.slice(0,4);
    //    let cardTwo = card_number.slice(5,11);
    //    let  cardThree = card_number.slice(12,17);
    //         card_number = cardOne + cardTwo + cardThree ;
    card_number = card_number.replace(/\s+/g, '');
        let payload = {
            userId, card_number,"is_default":"1", "method":"card", card_cvv, card_type, card_exp, person_name, address_zip
        }
       


    // let dummy =    {
    //         "userId":"1",
    //         "is_default": "1",
    //         "person_name": "sankar",
    //         "card_type": "MasterCard",
    //         "card_number": "5555555555554444",
    //         "card_exp": "0420",
    //         "card_cvv": "3333",
    //         "address_zip": "32945"
    //         }

        this.props.addPaymentMethod(token, payload)
    }

    componentDidMount() {
        // onDocumentReady function bind
        $(document).ready(function () {
          footer("#content");
      });

      // onResize bind of the function
      $(window).resize(function () {
          footer("#content");
      });
    }
    componentWillReceiveProps = nextProps =>{
        if(nextProps.addPaymentSuccessStatus){
           this.props.pageChange();
        }
    }


    render() {
      
        const { card_number,
            card_exp,
            card_cvv, person_name } = this.state
        return (
            <>

                <div>

                    <div class="login-bg ">
                        <div class="login-form card-design ">

                            <h1>Add Card</h1>

                            <form>

                                <div class="row">

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <input type="text" value={person_name} onChange={this.changeName} placeholder="Name On Card" />
                                            <span class="error">This value is required</span>

                                        </div> </div>

                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div class="form-group">
                                            <CreditCardInput
                                                cardNumberInputProps={{ value: card_number, onChange: this.handleCardNumberChange }}
                                                cardExpiryInputProps={{ value: card_exp, onChange: this.handleCardExpiryChange }}
                                                cardCVCInputProps={{ value: card_cvv, onChange: this.handleCardCVCChange }}
                                                fieldClassName="input"
                                            />
                                        </div> </div>
 
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">

                                        <button type="button" onClick={this.addCard} className="btnDefault">Add</button>
                                    </div>
                                </div>
                            </form>


                        </div>
                    </div>


                </div>



            </>
        )
    }
}

 
const mapStateToProps = state => ({

    loginDetails: state.commonReducer.loginDetails,
    profileDetails: state.commonReducer.profileDetails,
    addPaymentSuccessStatus : state.patientReducer.addPaymentSuccessStatus,
    message: state.employeeReducer.message
 });
 
 const mapDispatchToProps = dispatch => ({
    addPaymentMethod: (token, payload, ) => dispatch(addPaymentMethod(token, payload, )),
    
 });
 
 export default connect(
    mapStateToProps,
    mapDispatchToProps
 )(PatientPayment); 